import React from "react";

export default function SlideButton({ click, children, back, enabled }) {
  return (
    <div
      onClick={click}
      className={`slide-button ${back ? "--back" : "--next"}`}
      style={{
        filter: enabled ? "" : "grayscale(100%)",
        pointerEvents: enabled ? " " : "none",
      }}
    >
      {back ? (
        <div className="slide-button-arrow --back">
          <svg
            width="34"
            height="26"
            viewBox="0 0 34 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M34 13L1.11688 13" stroke="#333333" />
            <path d="M12.6258 25L0.999838 13L12.6258 1" stroke="#333333" />
          </svg>
        </div>
      ) : (
        ""
      )}
      <div className="slide-buttonInner">{children}</div>
      {!back ? (
        <div className="slide-button-arrow --next">
          <svg
            width="29"
            height="22"
            viewBox="0 0 29 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.993408 11H27.8978" stroke="black" />
            <path d="M18.4814 1L27.9935 11L18.4814 21" stroke="black" />
          </svg>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
